import { type PropsWithChildren, useMemo } from 'react';

import { TableContext } from '../../context';
import type { TableContextType } from '../../context/TableContext';

interface TableContextProviderProps
  extends TableContextType,
    PropsWithChildren {}

export function TableContextProvider({
  children,
  level = 2,
  size = 'md',
  spacing = 'none',
  stickyHeader = false,
  variant = 'default',
}: TableContextProviderProps) {
  const value = useMemo(
    () => ({ level, size, spacing, stickyHeader, variant }),
    [level, size, spacing, stickyHeader, variant],
  );

  return (
    <TableContext.Provider value={value}>{children}</TableContext.Provider>
  );
}

TableContextProvider.displayName = 'TableContextProvider';
